import Vue from "vue";
import VueRouter from "vue-router";
import HrView from "../views/HrView.vue";
import NotFoundViewVue from "../components/custom/NotFoundView.vue";

Vue.use(VueRouter);

const routes = [
  {
    meta: {
      requiresAuth: true,
    },
    path: "/home",
    name: "home",
    component: HrView,
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Attendance",
    name: "Attendance",
    component: () => import("../views/AttendanceView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/hr",
    name: "hr",
    component: () => import("../views/HrView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/opportunities",
    name: "opportunities",
    component: () => import("../views/OpportunitiesView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/salary",
    name: "salary",
    component: () => import("../views/SalaryView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/location",
    name: "location",
    component: () => import("../views/LocationView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/taskManager",
    name: "taskManager",
    component: () => import("../views/TaskManagerView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/tasks",
    name: "tasks",
    component: () => import("../components/taskManager/sideBar/Tasks.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/leaves",
    name: "leaves",
    component: () => import("../views/LeavesView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/users",
    name: "users",
    component: () => import("../views/UsersView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/EmployeeReviews",
    name: "EmployeeReviews",
    component: () => import("../components/hr/sideBar/EmployeeReviews.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Departments",
    name: "Departments",
    component: () => import("../components/hr/sideBar/Departments.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Jobs",
    name: "Jobs",
    component: () => import("../components/hr/sideBar/Jobs.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Courses",
    name: "Courses",
    component: () => import("../components/hr/sideBar/Courses.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/TrainingHistory",
    name: "TrainingHistory",
    component: () => import("../components/hr/sideBar/TrainingHistory.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/rolesList",
    name: "RolesList",
    component: () => import("../components/users/sideBar/Roles.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/JobHistory/:id",
    name: "JobHistory",
    component: () => import("../components/hr/sideBar/JobHistory.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/MoveEmployee",
    name: "MoveEmployee",
    component: () => import("../components/hr/sideBar/MoveEmployee.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/ErrorNotFound",
    name: "ErrorNotFound",
    component: () => import("../components/custom/ErroNotFound.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Attendance",
    name: "Attendance",
    component: () => import("../components/attendance/sideBar/Attendance.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/AttendanceTemplates",
    name: "AttendanceTemplates",
    component: () =>
      import("../components/attendance/sideBar/AttendanceTemplates.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Holidays",
    name: "Holidays",
    component: () => import("../components/attendance/sideBar/Holidays.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/Shifts",
    name: "Shifts",
    component: () => import("../components/attendance/sideBar/Shifts.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/employee-rptypes",
    name: "EmployeeRptypes",
    component: () =>
      import("../components/payroll/sideBar/RewardsAndPenalties.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/employee-rptypes-penalties",
    name: "EmployeeRptypes",
    component: () =>
      import("../components/payroll/sideBar/EmployeesPenalties.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/salaries",
    name: "Salaries",
    component: () => import("../components/payroll/sideBar/Salaries.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/ForgetPassword",
    name: "ForgetPassword",
    component: () => import("@/views/ForgetPasswordView.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/CodeCheck",
    name: "CodeCheck",
    component: () => import("@/views/CodeCheckView.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/ResetPassword",
    name: "ResetPassword",
    component: () => import("@/views/ResetPasswordView.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/Register",
    name: "Register",
    component: () => import("@/views/RegisterView.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/EmpShifts/:id",
    name: "EmpShifts",
    component: () =>
      import("../components/attendance/sideBar/EmployeesShifts.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/settings",
    name: "Settings",
    component: () => import("../views/SettingsView.vue"),
    children: [
      {
        path: "",
        name: "RpTypes",
        component: () => import("../components/settings/sidebar/RpTypes.vue"),
      },
      {
        path: "taxSlices",
        name: "taxSlices",
        component: () => import("../components/settings/sidebar/taxSlices.vue"),
      },
      {
        path: "empReveiwsSetting",
        name: "EmployeeReveiws",
        component: () =>
          import("../components/settings/sidebar/EmployeeReveiws.vue"),
      },
      {
        path: "trainingSetting",
        name: "TrainingSetting",
        component: () =>
          import("../components/settings/sidebar/TrainingSetting.vue"),
      },
      {
        path: "coursesDomains",
        name: "coursesDomains",
        component: () =>
          import("../components/settings/sidebar/CoursesDomains.vue"),
      },
      {
        path: "vacations",
        name: "vacations",
        component: () =>
          import("../components/settings/sidebar/vacationsTypes.vue"),
      },
      {
        path: "countries",
        name: "countries",
        component: () =>
          import("../components/settings/sidebar/CountriesView.vue"),
      },
      {
        path: "cities",
        name: "cities",
        component: () =>
          import("../components/settings/sidebar/CitiesView.vue"),
      },
      {
        path: "skills",
        name: "skills",
        component: () =>
          import("../components/settings/sidebar/SkillsSettings.vue"),
      },
      {
        path: "skillsLevels",
        name: "skillsLevels",
        component: () =>
          import("../components/settings/sidebar/SkillsLevels.vue"),
      },
      {
        path: "/directorates",
        name: "DirectoratesView",
        component: () =>
          import("../components/hr/sideBar/DirectoratesView.vue"),
      },
      {
        path: "rules",
        name: "rules",
        component: () => import("../components/settings/sidebar/rulesView.vue"),
      },
      {
        path: "conditions",
        name: "conditions",
        component: () =>
          import("../components/settings/sidebar/conditionsView.vue"),
      },
    ],
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/paidWages",
    name: "paidWages",
    component: () => import("../components/payroll/sideBar/PaidWage.vue"),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/employee-Wages",
    name: "employeeWages",
    component: () => import("../components/payroll/sideBar/EmployeeWages.vue"),
  },
  {
    meta: {
      requiresAuth: false,
    },
    path: "/:notFound(.*)",
    component: NotFoundViewVue,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {});
};
export default router;
